UAEditToolkitUserCtrl.$inject = ['user', 'adminApi', '$uibModalInstance']
export default function UAEditToolkitUserCtrl(user, adminApi, $modalInstance) {
  var grades = ['Pre-K', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
  var subjects = [
    'Reading',
    'Writing',
    'Math',
    'Behavior & SEL',
    'Pre-Kindergarten',
    'English Learners',
    'Autism',
    'Speech & Language',
    'Transition',
    'Alt Academics & Life Skills',
    'Functional Skills',
    'Occupational Therapy'
  ]

  this.grades = grades
  this.subjects = subjects
  this.user = user
  if (!user['grade_subject_prefs'].grades) {
    user['grade_subject_prefs'].grades = []
  }
  if (!user['grade_subject_prefs'].subjects) {
    user['grade_subject_prefs'].subjects = []
  }

  this.showError = false
  this.errorMessage = ''
  this.saving = false

  var selectedGrades = user.grade_subject_prefs.grades
  this.toggleGrade = function(grade, dirtyTrigger) {
    toggler(grade, selectedGrades)
    reorder(selectedGrades, grades)
    dirtyTrigger()
  }

  var selectedSubjects = user.grade_subject_prefs.subjects
  this.toggleSubject = function(subject, dirtyTrigger) {
    toggler(subject, selectedSubjects)
    reorder(selectedSubjects, subjects)
    dirtyTrigger()
  }

  function toggler(elem, arr) {
    if (!arr) {
      arr = []
    }
    var idx = arr.indexOf(elem)
    if (idx > -1) {
      arr.splice(idx, 1)
    } else {
      arr.push(elem)
    }
  }

  function reorder(arr, ref) {
    arr.sort(function(a, b) {
      var aIdx = ref.indexOf(a),
        bIdx = ref.indexOf(b)

      if (aIdx < bIdx) {
        return -1
      } else if (aIdx > bIdx) {
        return 1
      }
      return 0
    })
  }

  this.saveInfo = function(info) {
    this.saving = true
    this.showError = false

    adminApi.putToolkitUsers([this.user.uuid], this.user).then(
      function(result) {
        this.saving = false
        $modalInstance.close(result)
      }.bind(this),
      function(reason) {
        this.showError = true
        this.errorMessage = reason
        this.saving = false
      }.bind(this)
    )
  }
}
